var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"improvement",attrs:{"name":"improvement"}},[(_vm.isPost)?_c('post',{on:{"onClose":_vm.closePost,"onSubmit":_vm.submitUncomfortable}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"inner"},[_c('improvement-banner',{on:{"postUncomfortable":_vm.postUncomfortable}}),_vm._v(" "),_c('improvement-list')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a3e798f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/pc_uncomfortable/Improvement.vue
// module id = null
// module chunks = 